import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

import "./index.css";
import { BASE_PATH } from "./consts";
import initializeSentry from "./lib/sentry";

const router = createRouter({ routeTree, basepath: import.meta.env.DEV ? "/" : BASE_PATH });
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
  interface HistoryState {
    state: string;
  }
}

initializeSentry();

function bootstrap() {
  const rootElement = document.getElementById("root");
  createRoot(rootElement!).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
}

if (document.readyState === "complete") {
  bootstrap();
} else {
  window.addEventListener("load", bootstrap);
}
